import { OnInit, OnDestroy, Component, Input } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { ClientService } from 'src/app/base/services/client/client.service';
import { TranslateService } from '@ngx-translate/core';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { SfRequestTypes } from 'src/app/base/models/syncfusion-data';
import { IAbstractWidgetComponent, ParameterChangedData, WidgetMode } from './abstract-widget.component';

// attention: as long as we did not figure out how to declare the type properly, strictly follow the pattern
// T must extend WidgetWithGridBaseFormType
// type myFormType = WidgetWithGridBaseFormType & { additionalField: FormControl<string>; };
@Component({
  selector: 'app-base',
  template: ''
})
export abstract class WidgetWithGridBaseComponent<T extends { [K in keyof T]: AbstractControl<any, any>; }> extends GridBaseComponent implements OnInit, OnDestroy, IAbstractWidgetComponent {
  // IAbstractWidgetComponent part
  public mode: WidgetMode = WidgetMode.View;
  public parametersChanged: Subject<ParameterChangedData> = new Subject<ParameterChangedData>();
  public abstract defaultSizeX: number;
  public abstract defaultSizeY: number;
  public set isPersonalMode(value: boolean) {
    // override in child class for widgets with personal mode
  }
  public get isPersonalMode() {
    // override in child class for widgets with personal mode
    return false;
  }
  public abstract initializeParameters(panelId: string, serializedParameters: string, onDeleteCallback: (panelId: string) => void);
  // IAbstractWidgetComponent part end

  public editSettingsForm: FormGroup<T>;

  public defaultPageSize = 5;
  public override pageSettings = { pageSize: this.defaultPageSize, pageCount: 10, pageSizes: []};
  public pageSizes = [5, 10, 20, 50];

  private subscriptions: Subscription = new Subscription();

  constructor(
    protected fb: FormBuilder,
    protected override clientService: ClientService,
    protected override translateService: TranslateService,
    protected override showInactiveService: ShowInactiveService
  ) {
    super(clientService, translateService, showInactiveService);
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.editSettingsForm.get('pageSize')?.valueChanges.subscribe((pageSize: number) => { //TODO: change to typesafety as soon as type declaration is fixed
        this.grid.pageSettings.pageSize = pageSize;
      })
    );

    this.subscriptions.add(
      this.editSettingsForm.get('saveGridFilters')?.valueChanges.subscribe(() => { //TODO: change to typesafety as soon as type declaration is fixed
        this.editSettingsForm.get('gridFilter').setValue(null); //TODO: change to typesafety as soon as type declaration is fixed
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public override actionComplete(args: any) {
    if (this.editSettingsForm.get('saveGridFilters').value && args.requestType === SfRequestTypes.Filtering) { //TODO: change to typesafety as soon as type declaration is fixed
      const data = this.grid.getPersistData();
      const parsedData = JSON.parse(data);
      const filterSettings = parsedData.filterSettings ? JSON.stringify(parsedData.filterSettings) : null;

      if (filterSettings !== this.editSettingsForm.get('gridFilter').getRawValue()) { //TODO: change to typesafety as soon as type declaration is fixed
        this.editSettingsForm.get('gridFilter').setValue(filterSettings as any); //TODO: change to typesafety as soon as type declaration is fixed
        this.saveParameters();
      }
    }

    super.actionComplete(args);
  }

  public gridCreated() {
    if (this.editSettingsForm.get('gridFilter').value) { //TODO: change to typesafety as soon as type declaration is fixed
      try {
        const parsedFilterSettings = JSON.parse(this.editSettingsForm.get('gridFilter').value); //TODO: change to typesafety as soon as type declaration is fixed
        if (parsedFilterSettings) {
          this.grid.setProperties({ filterSettings: parsedFilterSettings });
        }
      } catch (error) {
        this.grid.clearFiltering();
      }
    }
  }

  public abstract saveParameters(): void;

  protected override initializeEditForm(data: any): void {
    throw new Error('Method not implemented.');
  }
  protected override getEditDialogTitleParams(rowData: any) {
    throw new Error('Method not implemented.');
  }
}
